var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label != null)?_c('div',{ref:"element",staticClass:"DataBand"},_vm._l((_vm.src._children),function(child,i){return _c('CollectorComponents',{key:i,attrs:{"parentOffset":_vm.label.offset,"src":child,"type":child._tipo},on:{"resize":_vm.label.resize}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }